<div class="item-group-row">
  <div class="info">
    @if (isExternalItemNumberGroup) {
      <div class="external-item-code">Commodity Code {{ viewModel.itemNumber }}</div>
    }
    @for (item of viewModel.unimportedItems; track item) {
      <div class="descriptions" [class.commodityGroup]="isExternalItemNumberGroup === true">
        <div>{{ item.fulfillmentDescription }}</div>
        <div>{{ item.customerDescription }}</div>
      </div>
    }
  </div>
  <button mat-button color="accent" class="button" (click)="commodityImport()">
    <mat-icon>get_app</mat-icon>
    Import Item
  </button>
</div>
